// A pitcher's wall is one developed surface (330 x 167 mm on the 1 L) that carries two zones on
// opposite faces, but each face is edited as a canvas of its own, the size of its zone. The 3D
// preview paints one texture over the whole wall, so the faces are laid onto a transparent
// surface at the place they have on the pitcher, and that is what the wall gets.

type TFacePlacement = {
    canvas: HTMLCanvasElement;
    /** Distance from the left edge of the developed surface to the left edge of the zone. */
    leftInMm: number;
};

type TDevelopedSurfaceParams = {
    faces: TFacePlacement[];
    surfaceInMm: { height: number; width: number };
    topInMm: number;
    zoneInMm: { height: number; width: number };
};

// The wall is seen from a phone, so a texture as sharp as the print file would only cost memory.
const MAX_TEXTURE_WIDTH_IN_PX = 2048;

function composeDevelopedSurface(params: TDevelopedSurfaceParams): HTMLCanvasElement {
    const { faces, surfaceInMm, topInMm, zoneInMm } = params;
    const surface = document.createElement('canvas');
    const [firstFace] = faces;
    if (!firstFace) {
        return surface;
    }
    const sourcePxPerMm = firstFace.canvas.width / zoneInMm.width;
    const scale = Math.min(1, MAX_TEXTURE_WIDTH_IN_PX / (surfaceInMm.width * sourcePxPerMm));
    const pxPerMm = sourcePxPerMm * scale;
    surface.width = Math.round(surfaceInMm.width * pxPerMm);
    surface.height = Math.round(surfaceInMm.height * pxPerMm);
    const context = surface.getContext('2d');
    if (!context) {
        console.error('composeDevelopedSurface: no 2d context, the pitcher keeps a blank wall');
        return surface;
    }
    faces.forEach((face) => {
        context.drawImage(face.canvas, face.leftInMm * pxPerMm, topInMm * pxPerMm, zoneInMm.width * pxPerMm, zoneInMm.height * pxPerMm);
    });
    return surface;
}

export { composeDevelopedSurface };
export type { TFacePlacement };
